import { h } from 'vue';
import { createVueApp } from '@vuejs/entry';
import { isPriceWithCodeEnabled } from '@vuejs/queries/usePriceWithCode';

let componentPromise;

// Wyspa "cena z kodem" w kafelku Twig. Wolac po kazdym wstawieniu kafelkow
// (start strony, filtry) - zamontowane juz elementy sa pomijane.
export const mountPricesWithCode = async (root = document) => {
    if (!isPriceWithCodeEnabled()) return;

    // eslint-disable-next-line no-underscore-dangle
    const isPending = (el) => !el.__vue_app__;
    const elements = [...root.querySelectorAll('.product-price-with-code-app')].filter(isPending);

    if (!elements.length) return;

    if (!componentPromise) {
        componentPromise = import(
            /* webpackChunkName: "ProductItemPriceWithCode" */ '@vuejs/components/product/item/ProductItemPriceWithCode.vue'
        ).then((m) => m.default);
    }

    const ProductItemPriceWithCode = await componentPromise;

    elements.filter(isPending).forEach((el) => {
        // Blad jednej wyspy nie moze zatrzymac montowania kolejnych kafelkow.
        try {
            const props = { productId: el.dataset.productId };

            createVueApp({ render: () => h(ProductItemPriceWithCode, props) }).mount(el);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('[PriceWithCode] mount error:', error);
        }
    });
};
